import React from 'react';

/**
 * Funding progress bar component
 * Design: High-contrast, rectangular, monospace labels
 */
export default function ProgressBar({
  current,
  target,
  label,
  showAmount = true,
  showPercentage = true,
  className = '',
}) {
  const percentage = target > 0 ? Math.min((current / target) * 100, 100) : 0;
  const isFunded = target > 0 && current >= target;

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <div className="flex justify-between items-center mb-2">
          <span className="font-mono text-sm font-semibold uppercase tracking-wider text-black">
            {label}
          </span>
          {showPercentage && (
            <span className="font-mono text-sm font-semibold text-black">
              {Math.round(percentage)}%
            </span>
          )}
        </div>
      )}

      {/* Progress bar container */}
      <div className="w-full h-6 border-2 border-black bg-white">
        <div
          className={`h-full transition-all duration-500 ${
            isFunded ? 'bg-green-500' : 'bg-black'
          }`}
          style={{ width: `${percentage}%` }}
        />
      </div>

      {showAmount && (
        <div className="flex justify-between items-center mt-2">
          <span className="font-mono text-xs text-gray-600 uppercase tracking-wider">
            P${current.toLocaleString()} RAISED
          </span>
          <span className="font-mono text-xs text-gray-600 uppercase tracking-wider">
            P${target.toLocaleString()} GOAL
          </span>
        </div>
      )}

      {isFunded && (
        <div className="mt-2 px-3 py-1 bg-green-500 text-white inline-block">
          <span className="font-mono text-xs font-semibold uppercase tracking-wider">
            FULLY FUNDED
          </span>
        </div>
      )}
    </div>
  );
}

/**
 * Compact progress bar for list items
 */
export function ProgressBarCompact({
  current,
  target,
  className = '',
}) {
  const percentage = target > 0 ? Math.min((current / target) * 100, 100) : 0;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="flex-1 h-2 border border-black bg-white">
        <div
          className="h-full bg-black transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="font-mono text-xs font-semibold text-black min-w-[3rem] text-right">
        {Math.round(percentage)}%
      </span>
    </div>
  );
}
